import React from 'react';

import dayjs from '~/timeInit';

import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';

import { Brand, OfferBrandSchedule } from '~/services/ExperiencesService';

type Props = {
  brandSchedules: Array<OfferBrandSchedule>;
  allBrands: Array<Brand> | null;
};

const formatDate = (dateStr?: string | null): string => {
  if (!dateStr) {
    return '—';
  }
  const date = dayjs.utc(dateStr);
  if (!date.isValid()) {
    return '—';
  }
  return date.format('ddd MMM DD YYYY');
};

const getBrandDisplayName = (brandId: string, allBrands: Array<Brand> | null): string => {
  const brand = allBrands?.find((b) => b.id === brandId);
  return brand?.name ?? brandId;
};

export default function OfferScheduleTable({ brandSchedules, allBrands }: Props) {
  if (!brandSchedules?.length) {
    return <Typography color="text.secondary">No schedule data available</Typography>;
  }

  return (
    <TableContainer component={Paper} variant="outlined">
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: 'grey.100' }}>
            <TableCell>
              <strong>BRAND</strong>
            </TableCell>
            <TableCell>
              <strong>RUN DATE</strong>
            </TableCell>
            <TableCell>
              <strong>OFFLINE DATE</strong>
            </TableCell>
            <TableCell>
              <strong>EXPIRY DATE</strong>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {brandSchedules.map((schedule) => (
            <TableRow key={schedule.brandId}>
              <TableCell>{getBrandDisplayName(schedule.brandId, allBrands)}</TableCell>
              <TableCell>{formatDate(schedule.startDate)}</TableCell>
              <TableCell>{formatDate(schedule.endDate)}</TableCell>
              <TableCell>{formatDate(schedule.expiryDate)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
